import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private baseurl = `https://qaapi.jahernotice.com/`;

  constructor(private http: HttpClient) {  }

  Postdata(url: string, data) {
    return this.http.post(`${this.baseurl}${url}`, data);
  }

  Getdata(url : string){
    return this.http.get(`${this.baseurl}${url}`);
  }

}
